import './ccf-double-arrow-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfDoubleArrowIconProps extends SvgIconProps {}

/**
 * CcfDoubleArrowIcon used to disply double arrow icon in the contact card panel
 * @param props - CcfDoubleArrowIconProps
 * @example -- <CcfDoubleArrowIcon />
 */
export function CcfDoubleArrowIcon(props: CcfDoubleArrowIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24"  {...props}>
      <g id="Chevron" clipPath="url(#clip-Chevron)">
        <g id="Group_119454" data-name="Group 119454" transform="translate(32.904 32.141) rotate(180)">
          <rect id="Rectangle_22331" data-name="Rectangle 22331" width="40" height="40" transform="translate(0.904 0.141)" fill="#fff" opacity="0"/>
          <path id="Union_1528" data-name="Union 1528" d="M11.862,11.048,6.337,5.742l-5.2,5.2a.812.812,0,0,1-.977,0,.814.814,0,0,1,0-.975L5.794,4.549c.113-.217.328-.217.543-.217a.793.793,0,0,1,.65.217l5.849,5.523a.8.8,0,0,1,0,.975.632.632,0,0,1-.448.164A.973.973,0,0,1,11.862,11.048Zm0-4.44-5.525-5.2-5.091,5.2a.816.816,0,0,1-.976,0,.817.817,0,0,1,0-.977L5.794.108A.828.828,0,0,1,6.337,0a.8.8,0,0,1,.65.215l5.849,5.527a.8.8,0,0,1,0,.974.556.556,0,0,1-.395.15A.829.829,0,0,1,11.862,6.608Z" transform="translate(14 15.216)"/>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfDoubleArrowIcon;
